// Plugins and Libraries
import "jquery";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

// Styles to compile to the frontend
import "./style.scss";

// Other Scripts
import "./scripts/app.js";
